module.exports = __webpack_public_path__ + "img/manifesto-splash.e02d368b.svg";